import React, { useContext } from "react";
import "../Modal/styles/styles.css";
import "../../styles/global.css";
import AccreditationButton from "../AccreditationButton/AccreditationButton";
import { icons } from "../../constants";
import { TranslationsContext } from "../../utils/TranslationsContext";
import { handleLogout } from "../../utils/methods";
import useSessionExpiry from "../../hooks/useSessionExpiry";

const formatRemaining = (ms) => {
  const totalSeconds = Math.ceil(ms / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = String(totalSeconds % 60).padStart(2, "0");
  return `${minutes}:${seconds}`;
};

// No overlay-click / Escape dismissal on purpose: closing it without
// extending would just let the session lapse silently, which is exactly
// what this modal exists to prevent.
const SessionExpiryModal = () => {
  const { t } = useContext(TranslationsContext);
  const { showWarning, remainingMs, extend, extending } = useSessionExpiry();

  if (!showWarning) return null;

  return (
    <div
      className="flex-direction-column items-center justify-center confirmation-modal-wrapper"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="session-expiry-title"
    >
      <div
        className="flex-direction-column gap-48 confirmation-modal"
        style={{ borderTop: "10px solid var(--Red-box)" }}
      >
        <div
          className="flex-direction-column gap-12 inria-sans-400 font-24"
          style={{ color: "var(--text-black)" }}
        >
          <p id="session-expiry-title" className="inria-sans-700 width-100">
            {t("SESSION_EXPIRING_TITLE")}
          </p>
          <p className="font-16" aria-live="polite">
            {t("SESSION_EXPIRING_MESSAGE").split("{{time}}").join(formatRemaining(remainingMs))}
          </p>
        </div>
        <div className="flex-direction-row gap-12">
          <AccreditationButton
            title={t("SESSION_EXTEND")}
            icon={icons.accept}
            type="accept"
            onClick={extend}
            disabled={extending}
            className={"confirmation-modal-accept-btn"}
          />
          <AccreditationButton
            title={t("LOGOUT")}
            icon={icons.decline}
            type="close"
            onClick={handleLogout}
            className={"confirmation-modal-decline-btn"}
          />
        </div>
      </div>
    </div>
  );
};

export default SessionExpiryModal;
